// Product cards embedded in Learn blog articles used to be hand-typed HTML with a
// snapshot price/name baked in - those silently went stale every time a price changed
// elsewhere on the site. This custom element replaces that pattern: article authors just
// drop in <zahav-live-product-card data-handle="..." data-eyebrow="..." data-note="...">,
// and it fetches the product's live price/title/image from Shopify's own public
// /products/<handle>.js endpoint at render time, so the card can never drift from the
// real listing again.
class ZahavLiveProductCard extends HTMLElement {
  connectedCallback() {
    if (this.dataset.zahavInit) return;
    this.dataset.zahavInit = 'true';

    var handle = this.dataset.handle;
    if (!handle) return;

    this.innerHTML = '<div class="zahav-live-product-card__skeleton"></div>';

    fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.ok ? r.json() : Promise.reject(r.status);
      })
      .then(this.#render.bind(this))
      .catch(function () {
        // A missing/renamed/unpublished product shouldn't show stale or broken content -
        // just remove the card rather than risk showing something wrong again.
        this.remove();
      }.bind(this));
  }

  #render(product) {
    var url = '/products/' + product.handle;
    var image = product.featured_image || (product.images && product.images[0]) || '';
    if (image && image.indexOf('//') === 0) image = 'https:' + image;

    var price = '$' + (product.price / 100).toFixed(2).replace(/\.00$/, '');
    if (product.price_varies) price = 'from ' + price;

    var note = this.dataset.note;
    var priceLine = note ? note + ', ' + price + '.' : price + '.';

    var eyebrow = this.dataset.eyebrow;
    var title = this.#escape(product.title);

    this.innerHTML =
      '<a href="' + url + '" class="zahav-live-product-card__media">' +
        (image ? '<img src="' + image + '" alt="' + title + '" loading="lazy">' : '') +
      '</a>' +
      '<div class="zahav-live-product-card__body">' +
        (eyebrow ? '<div class="zahav-live-product-card__eyebrow">' + this.#escape(eyebrow) + '</div>' : '') +
        '<a href="' + url + '" class="zahav-live-product-card__title">' + title + '</a>' +
        '<p class="zahav-live-product-card__price">' + this.#escape(priceLine) + '</p>' +
        '<a href="' + url + '" class="zahav-live-product-card__cta">Shop the piece &rarr;</a>' +
      '</div>';
  }

  #escape(str) {
    return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
}

if (!customElements.get('zahav-live-product-card')) {
  customElements.define('zahav-live-product-card', ZahavLiveProductCard);
}
